import Link from 'next/link';
import CustomImage from '@components/common/image';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Props {
  size?: 'small' | 'large';
  className?: string;
}

const MatchingBanner = ({ size = 'large', className }: Props) => {
  return (
    <Link href={RouteUrl.MATCH_INTRODUCE} className={cx('matchingBanner', size, className)}>
      <CustomImage
        className={cx('bannerImage')}
        src="/img/v2/components/index/matchingBanner.png"
        alt="내 프로필과 역량 정보에 딱 맞는 기업에게 제안 받아 보세요."
        width={892}
        height={120}
        pointer
      />

      <div className={cx('hidden')}>
        <p>
          더 이상 스펙, 자기소개서 신경쓰지 마세요.
          <br />
          역량만으로 취업하는 우리가 기다려 온 매칭 서비스
        </p>
        <p>내 프로필과 역량 정보에 딱 맞는 기업에게 제안 받아 보세요.</p>
      </div>
      <button className={cx('button')}>잡다매칭 시작하기</button>
    </Link>
  );
};

export default MatchingBanner;
